import styled from "styled-components";
import { Grid, Typography } from "@mui/material";
import ThemeButton from "components/Buttons/ThemeButton";
import { LoyaltyPointsV2 } from "styles/general_styles";
import { expandOverlay, moveDiagonally } from "./animations";

export const BuyItAllStyled = styled.div`
	display: flex;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	padding: 0 0.7em;
	position: absolute;
	bottom: 5%;
	right: 0px;
	left: 0px;
	gap: 0.5em;
	//font-size: clamp(1px, 4.3dvw, 30px);
	font-size: 1.2rem;

	@media (orientation: landscape) {
		font-size: 1.3rem;
		padding: 0em;
	}
`;

export const OfferGridItem = styled(Grid)`
	flex-basis: 33.3333%;
	max-width: 33.3333%;

	@media (orientation: landscape) {
		flex-basis: 31%;
		max-width: 31%;
	}
`;

export const FooterGridItem = styled(Grid)`
	flex-basis: 100%;
	max-width: 100%;

	@media (orientation: landscape) {
		flex-basis: 50%;
		max-width: 50%;
	}
`;

export const LockedOffer = styled.div`
	position: absolute;
	width: calc(100% - 0.44em);
	height: calc(100% - 0.44em);
	background: rgba(0, 0, 0, 0.4);
	border-radius: 12px;
	z-index: 1;
	animation: ${expandOverlay} 0.2s forwards;
`;

export const FingerPointer = styled.img`
	width: 3.2em;
	position: absolute;
	bottom: -3.5em;
	right: -1.2em;
	z-index: 2;
	animation: ${moveDiagonally} 2s infinite;
`;

// prettier-ignore
export const BuyItAllItem = styled.div<{ tier: number }>(({ tier }) => `
	position: relative;
	background-color: rgba(51, 51, 51, 0.3);
	border: 0.22em solid ${
		(tier === 0 && "#C9832E") ||
		(tier === 1 && "#D9D9D9") ||
		(tier === 2 && "#FBBD05")
	};
	border-radius: 12px;
	padding: 0.5em;
	height: auto;
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
`);

// prettier-ignore
export const Items = styled.div<{ tier: number }>(({ tier }) => `
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	gap: ${tier * 0.45}em;

	@media (orientation: landscape) {
		flex-direction: row;
		gap: unset;
		margin: ${tier * 0.4}em;
	}
`);

// prettier-ignore
export const RewardItem = styled.div<{ width: string }>(({ width }) => `
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	flex-basis: ${width};
	box-sizing: border-box;
	padding: 0.05em;
`);

export const RewardAmount = styled(Typography)`
	color: #fff;
	font-weight: 700;
	font-size: 1em;
`;

export const ItemImage = styled.img`
	width: 2.7em;
	height: 2.7em;
	object-fit: contain;
	justify-self: center;
	align-self: center;
`;

export const Footer = styled.div`
	button {
		width: 100%;
		padding: 0.4em 0.2em;
	}
	&.loyalty-reward {
		grid-template-columns: minmax(5.5em, auto) auto;
		grid-gap: 0.6em;
	}
`;

export const LoyaltyPoints = styled.div`
	background-color: rgba(0, 0, 0, 0.51);
	color: #fff;
	font-size: 0.7em;
	font-weight: 700;
	padding: 0.5em 0.8em;
	//margin: 0.3rem 0rem;
	border-radius: 100px;
	line-height: 1.2em;

	> div {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 0.2em;
	}
`;

export const CustomLoyaltyPointsV2 = styled(LoyaltyPointsV2)`
	font-size: 0.7em;
	min-height: 1.5em;
	display: flex;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	line-height: auto;
	padding: 0.2em 0.8em;
	gap: 0.1em;
`;

export const LoyaltyValue = styled.div`
	font-size: 0.9em;
	line-height: 0.9em;
`;

export const BuyItAllFooterText = styled.p`
	color: white;
	text-align: center;
	text-shadow: 0px 4px 0 #000, -1px 1px 0 #000, 1px -1px 0 #000,
		-1px -1px 0 #000, 0px 1px 0 #000, 0px -1px 0 #000, -1px 0px 0 #000,
		1px 0px 0 #000, 1px 1px 0 #000, -1px 1px 0 #000, 1px -1px 0 #000,
		-1px -1px 0 #000, 0px 1px 0 #000, 0px -1px 0 #000, -1px 0px 0 #000,
		1px 0px 0 #000, 1px 1px 0 #000, -1px 1px 0 #000, 1px -1px 0 #000,
		-1px -1px 0 #000, 1px 1px 0 #000, -1px 1px 0 #000, 1px -1px 0 #000,
		-1px -1px 0 #000;
	-webkit-text-stroke-width: 1.5;
	-webkit-text-stroke-color: #000;
	font-family: "Baloo";
	font-size: 1.5em;
	font-style: normal;
	font-weight: 400;
	line-height: 100%;
	margin: 0;
`;

export const Button = styled(ThemeButton)`
	height: 2.5em;
	font-size: 0.9em;
`;

export const BuyItAllButton = styled(ThemeButton)`
	font-size: 1.1em;
	width: 14em;
	height: 2.6em;

	@media (orientation: landscape) {
		height: 2.4em;
	}
`;

// prettier-ignore
export const BestValueBadge = styled.div<{ backgroundImage: string }>(({ backgroundImage }) => `
	position: absolute;
	z-index: 1;
	top: -2.6em;
	right: 0px;
	width: 4.5em;
	height: 4.5em;
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
	background-image: url(${backgroundImage});
	background-size: cover;
	transform: rotate(-21deg);
	color: #fff;
	font-family: "Baloo";
	font-size: 0.65em;
	line-height: 0.9em;
	text-shadow: 0px 0px 0 #474747, -1px 1px 0 #474747, 1px -1px 0 #474747,
		-1px -1px 0 #474747, 0px 1px 0 #474747, 0px -1px 0 #474747, -1px 0px 0 #474747,
		1px 0px 0 #474747, 1px 1px 0 #474747, -1px 1px 0 #474747, 1px -1px 0 #474747,
		-1px -1px 0 #474747, 0px 1px 0 #474747, 0px -1px 0 #474747, -1px 0px 0 #474747,
		1px 0px 0 #474747, 1px 1px 0 #474747, -1px 1px 0 #474747, 1px -1px 0 #474747,
		-1px -1px 0 #474747, 1px 1px 0 #474747, -1px 1px 0 #474747, 1px -1px 0 #474747,
		-1px -1px 0 #474747;
	transition: ease .3s;

	> span {
		width: 3em;
	}

	&.buy-all-button {
		top: 50%;
		transform: translate(50%, -50%) rotate(-21deg);
		right: 1em;
	}

	&.blocked-offer {
		filter: grayscale(1.0) brightness(45%);
	}
`);
